/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
export interface IKeyEvent {
  ctrlKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
  metaKey?: boolean;
  key: string;
}

export class KeyEvent {

  public static getHashCode(keyEvent: IKeyEvent): string {
    if (keyEvent.key.length > 1) {
      return "000000000000";
    }
    const ctrl = keyEvent.ctrlKey ? "1" : "0";
    const shift = keyEvent.shiftKey ? "1" : "0";
    const alt = keyEvent.altKey ? "1" : "0";
    const meta = keyEvent.metaKey ? "1" : "0";
    return `${ctrl}${shift}${alt}${meta}${keyEvent.key.charCodeAt(0).toString(2).toLowerCase()}`;
  }

  public static fromHashCode(str: string): IKeyEvent {
    if (str.length < 12) {
      throw Error(`${str} is not a valid key event`);
    }
    return {
      ctrlKey: str[0] === "1",
      shiftKey: str[1] === "1",
      altKey: str[2] === "1",
      metaKey: str[3] === "1",
      key: String.fromCharCode(parseInt(parseInt(str.substring(4), 2).toString(10), 10)),
    };
  }

  public static toString(keyEvent: IKeyEvent): string {
    const combo = [];
    if (keyEvent.ctrlKey) combo.push("Ctrl");
    if (keyEvent.shiftKey) combo.push("Shift");
    if (keyEvent.altKey) combo.push("Alt");
    if (keyEvent.metaKey) combo.push("Meta");
    combo.push(keyEvent.key);
    return combo.join(" + ");
  }

}
